import { render, staticRenderFns } from "./number-and-placed-date.vue?vue&type=template&id=3e71d265&lang=pug&"
import script from "./number-and-placed-date.vue?vue&type=script&lang=js&"
export * from "./number-and-placed-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports